export const GLOBAL_CSS_STYLE_ID = 'wix-global-css'
export const GLOBAL_CSS_COMPONENT_TYPE = 'GLOBAL_CSS'
export const GLOBAL_CSS_NAMESPACE_PREFIX = '#SITE_CONTAINER #main_MF#main_MF .css-editing-scope'
export const BLOCKED_EDITOR_PROPS = [
	'animation',
	'transition-delay',
	'transition',
	'transition-duration',
	'transition-timing-function',
	'transition-property',
]
export const SHOULD_DISABLE_ANIMATIONS_FLAG = 'shouldDisableAnimations'
export const VH_SCALING_EXPERIMENT = 'vhScalingGeneratedCss'
